export const CATALOG_URL = process.env.CATALOG_URL;
export const TILE_SOURCE_TEMPLATE = process.env.TILE_SOURCE_TEMPLATE;
export const STAC_PROXY_URL = process.env.STAC_PROXY_URL;
export const TILE_PROXY_URL = process.env.TILE_PROXY_URL;
export const PATH_PREFIX = process.env.PATH_PREFIX;
export const HISTORY_MODE = process.env.HISTORY_MODE;